'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _LoadingFilled = require('./lib/icons/LoadingFilled');
  
  
  var _default = _LoadingFilled;
  exports.default = _default;
  module.exports = _default;